import React from "react";
import FallbackImage from "../Common/ImageWrapper";
import {
  formatNotificationTime,
  getNotificationIcon,
} from "../../utils/notificationTypes";

export default function NotificationCard({
  notification,
  onClick,
  compact = false,
  className = "",
}) {
  if (!notification) return null;

  const icon = getNotificationIcon(notification.type);
  const timeText = formatNotificationTime(notification.created_at);
  const messageText =
    typeof notification.message === "string"
      ? notification.message
      : notification.message?.message || "View details";
  const isUnread = !notification.is_read;

  return (
    <div
      role="button"
      tabIndex={0}
      className={`notification-card ${
        isUnread ? "notification-card--unread" : "notification-card--read"
      } ${className}`.trim()}
      onClick={() => onClick?.(notification)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.(notification);
        }
      }}
    >
      <div className="notification-card__icon">
        <FallbackImage src={icon} height={compact ? "18" : "20"} width={compact ? "18" : "20"} />
      </div>
      <div className="notification-card__body">
        <p className="notification-card__title">
          {typeof notification.title === "string" ? notification.title : "Notification"}
        </p>
        <p className="notification-card__message">{messageText}</p>
        <span className="notification-card__time">{timeText}</span>
      </div>
    </div>
  );
}
